import { useCallback, useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import Api from '../../../util/api';
import { partial } from '../../../util/translation/translation';

const p = partial('chat');

// The club's blocked chat users, and blocking/unblocking with a toast
const useChatUserBlocking = () => {
  const [blockedUsers, setBlockedUsers] = useState([]);

  const fetchBlockedUsers = useCallback(async () => {
    try {
      setBlockedUsers(await Api.chat.getBlockedUsers());
    } catch {
      setBlockedUsers([]);
    }
  }, []);

  useEffect(() => {
    fetchBlockedUsers();
  }, [fetchBlockedUsers]);

  const isBlocked = useCallback(
    (userId) => blockedUsers.some((user) => user.userId === userId),
    [blockedUsers]
  );

  const blockUser = async ({ userId, userName, reason, durationHours }) => {
    try {
      await Api.chat.blockUser({ userId, userName, reason, durationHours });
      toast.success(p('userBlocked', { name: userName || '' }));
    } catch (err) {
      toast.error(err || p('userBlockERROR'));
    } finally {
      fetchBlockedUsers();
    }
  };

  const unblockUser = async (userId) => {
    try {
      await Api.chat.unblockUser(userId);
      toast.success(p('userUnblocked'));
    } catch (err) {
      toast.error(err || p('userUnblockERROR'));
    } finally {
      fetchBlockedUsers();
    }
  };

  return { blockedUsers, isBlocked, blockUser, unblockUser, fetchBlockedUsers };
};

export default useChatUserBlocking;
